import { render, staticRenderFns } from "./predictionanswer.vue?vue&type=template&id=602ad2ba&"
import script from "./predictionanswer.vue?vue&type=script&lang=js&"
export * from "./predictionanswer.vue?vue&type=script&lang=js&"
import style0 from "./predictionanswer.vue?vue&type=style&index=0&id=602ad2ba&prod&lang=css&"
import style1 from "./predictionanswer.vue?vue&type=style&index=1&id=602ad2ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports